import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
  onClick?: () => void;
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-ink-soft">
        {items.map((item, index) => {
          const current = index === items.length - 1;
          const content = item.to ? (
            <Link to={item.to} className="font-medium no-underline hover:text-forest">
              {item.label}
            </Link>
          ) : item.onClick && !current ? (
            <button type="button" onClick={item.onClick} className="font-medium hover:text-forest">
              {item.label}
            </button>
          ) : (
            <span
              aria-current={current ? 'page' : undefined}
              className={current ? 'font-semibold text-ink' : undefined}
            >
              {item.label}
            </span>
          );

          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {index > 0 && (
                <span aria-hidden="true" className="text-ink-faint">
                  /
                </span>
              )}
              {content}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
